import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation CloseActivityByCustomer($activityId: ID!) {
  closeCustomerActivity(activityId: $activityId)
}`;

function closeActivityByCustomer(activityId) {
  return apollo.client.mutate({
    variables: {
      activityId,
    },
    mutation,
  }).then((res) => {
    if (res.data.closeCustomerActivity) {
      return {
        id: activityId,
        state: 'closed',
      };
    }
    throw res;
  });
}

export default closeActivityByCustomer;
